<template>
  <header class="header">
    <div class="header-content">
      <div class="logo" @click="goToHome">
        <img :src="BRAND_ASSETS.logo" alt="logo" class="logo-image" />
      </div>
      <nav class="nav-links">
        <div class="custom-dropdown">
          <button class="dropbtn">
            漫画地区 <AppIcon name="chevronDown" size="xs" class="drop-icon" aria-label="" />
          </button>
          <div class="dropdown-content">
            <a @click="goToJapanRegion">日本</a>
          </div>
        </div>
        <div
          class="custom-dropdown"
          @mouseenter="showDropdown"
          @mouseleave="hideDropdown"
        >
          <button class="dropbtn" @click="toggleDropdown">
            漫画类型 <AppIcon name="chevronDown" size="xs" class="drop-icon" aria-label="" />
          </button>
          <div v-if="isDropdownOpen" class="dropdown-content">
            <a @click="goToCategory([10, 90])">热血竞技</a>
            <a @click="goToCategory([20, 30])">青春恋爱</a>
            <a @click="goToCategory([40, 70])">冒险悬疑</a>
            <a @click="goToCategory([100, 110])">幽默格斗</a>
            <a @click="goToCategory([70, 71])">恐怖惊悚</a>
          </div>
        </div>
        <a @click="goToRequestComic" class="nav-item">求漫画</a>
      </nav>
      <NavBarSearch :auth-token="authToken" class="nav-search-bar" />
      <div class="nav-icons">
        <div class="nav-interaction">
          <button
            ref="bellBtn"
            type="button"
            class="icon-button"
            aria-label="互动消息"
            aria-haspopup="dialog"
            :aria-expanded="isInteractionPopoverOpen"
            @click.stop="handleBellClick"
          >
            <AppIcon name="bell" size="md" aria-label="互动消息" />
            <span
              v-if="interactionUnreadCount > 0"
              class="interaction-unread-badge"
              aria-hidden="true"
            >
              {{ interactionUnreadDisplay }}
            </span>
          </button>
          <InteractionMessagesPopover
            v-model:visible="isInteractionPopoverOpen"
            :get-anchor="getBellAnchor"
            :is-mobile="isMobile"
            @unread-sync="fetchInteractionUnreadCount"
          />
        </div>
        <template v-if="user">
          <div
            ref="userArea"
            class="user-info trigger-area"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
            @click="handleUserAreaClick"
          >
            <img
              ref="userAvatar"
              :src="user.avatar"
              alt="用户头像"
              class="user-avatar"
            />
            <span class="user-name">{{ user.name }}</span>
            <transition name="slide">
              <UserCard
                v-if="isUserCardVisible"
                ref="userCard"
                :showUserCard="isUserCardVisible"
                :user="user"
                @hide="hideUserCard"
                @logout="emit('logout')"
                @click.stop
              />
            </transition>
          </div>
        </template>

        <template v-else>
          <button @click="emit('show-login')" class="navbar-login-button">
            <AppIcon name="user" size="sm" aria-label="" />
            <span class="navbar-login-button__label">登录</span>
          </button>
        </template>
        <button class="hamburger-menu" @click="toggleMenu">
          <AppIcon name="menu" size="md" aria-label="菜单" />
        </button>
      </div>

      <div
        v-if="isMenuOpen"
        class="side-menu-overlay"
        @click="toggleMenu"
      ></div>
      <div :class="['side-menu', { open: isMenuOpen }]" @click.stop>
        <div class="menu-content">
          <div class="custom-dropdown">
            <button type="button" class="dropbtn" @click.stop="toggleRegionDropdown">
              <span class="dropbtn-label">漫画地区</span>
              <AppIcon
                name="chevronDown"
                size="sm"
                class="drop-icon"
                :class="{ rotated: isRegionDropdownOpen }"
                aria-label=""
              />
            </button>
            <div v-if="isRegionDropdownOpen" class="dropdown-content">
              <a @click.stop="goToJapanRegion">日本</a>
            </div>
          </div>
          <div class="custom-dropdown">
            <button type="button" class="dropbtn" @click.stop="toggleDropdown">
              <span class="dropbtn-label">漫画类型</span>
              <AppIcon
                name="chevronDown"
                size="sm"
                class="drop-icon"
                :class="{ rotated: isDropdownOpen }"
                aria-label=""
              />
            </button>
            <div v-if="isDropdownOpen" class="dropdown-content">
              <a @click="goToCategory([10, 90])">热血竞技</a>
              <a @click="goToCategory([20, 30])">青春恋爱</a>
              <a @click="goToCategory([40, 70])">冒险悬疑</a>
              <a @click="goToCategory([100, 110])">幽默格斗</a>
              <a @click="goToCategory([70, 71])">恐怖惊悚</a>
            </div>
          </div>
          <a @click.stop="goToRequestComic" class="nav-item">求漫画</a>
        </div>
      </div>
    </div>
    <div
      v-if="isUserCardVisible && isMobile"
      class="user-card-overlay"
      @click="handleOverlayClick"
      @touchstart="handleOverlayClick"
    ></div>
  </header>
</template>

<script setup>
import UserCard from '@/features/user/components/UserCard.vue'
import InteractionMessagesPopover from '@/features/message/components/InteractionMessagesPopover.vue'
import NavBarSearch from '@/shared/components/NavBarSearch.vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { useNavBar } from '@/shared/composables/useNavBar'
import { BRAND_ASSETS } from '@/shared/assets/manifest'

const props = defineProps({
  authToken: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['show-login', 'logout'])

const {
  user,
  isUserCardVisible,
  isMenuOpen,
  isDropdownOpen,
  isRegionDropdownOpen,
  isMobile,
  isInteractionPopoverOpen,
  interactionUnreadCount,
  interactionUnreadDisplay,
  userAvatar,
  userCard,
  bellBtn,
  userArea,
  toggleDropdown,
  toggleRegionDropdown,
  showDropdown,
  hideDropdown,
  goToCategory,
  goToJapanRegion,
  goToRequestComic,
  hideUserCard,
  handleUserAreaClick,
  handleOverlayClick,
  handleMouseEnter,
  handleMouseLeave,
  goToHome,
  getBellAnchor,
  fetchInteractionUnreadCount,
  handleBellClick,
  toggleMenu,
} = useNavBar(props, emit)
</script>

<style scoped src="@/shared/styles/NavBar.css"></style>
